import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { Layout } from './components/Layout';
import { ToastProvider } from './components/ui/Toast/ToastProvider';
// import './custom.css';
import './App.scss';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <ToastProvider>
        <Layout>
          <Routes>
            {AppRoutes.map((route, index) => {
              const { element, requireAuth, ...rest } = route;
              return <Route key={index} {...rest} element={requireAuth ? <AuthorizeRoute {...rest} element={element} /> : element} />;
            })}
          </Routes>
        </Layout>
      </ToastProvider>
    );
  }
}
